import React from "react";
import { compose } from "redux";
import { Field } from "redux-form/immutable";
import { MenuItem } from "@material-ui/core";

import {
  VIEW_TYPES,
  CREATE_VIEW_FORM,
} from "features/planner/planner.constants";

import TextField from "app/components/form/TextField";
import { viewTypeToString } from "features/planner/planner.mappers";

const CreateViewForm = ({ onSubmit }) => (
  <form id={CREATE_VIEW_FORM.ID} onSubmit={onSubmit}>
    <Field
      required
      autoFocus
      fullWidth
      label="Name"
      component={TextField}
      name={CREATE_VIEW_FORM.NAME}
    />
    <Field
      fullWidth
      select
      label="Type"
      component={TextField}
      name={CREATE_VIEW_FORM.TYPE}
    >
      {Object.values(VIEW_TYPES).map(viewType => (
        <MenuItem key={viewType} value={viewType}>
          {viewTypeToString(viewType)}
        </MenuItem>
      ))}
    </Field>
  </form>
);

export default compose(React.memo)(CreateViewForm);
